import React, { Component } from "react";
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import { connect } from "react-redux";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Swal from "sweetalert2";
import Select from "react-select";
import { USER_STUDIO_WALL, addApp, updateApp } from '../../../../../../../actions/sceneActions'
import './noticeboardUpload/notice.css'
import { customClass, stripTrailingSlash } from '../../../../../../../utils'
import NoticeBoardPreview from "../../../_metronic/_partials/apps/noticeboard";
import {
  Card,
  Button,
  Row,
  Col,
  Form,
} from "react-bootstrap";
import { DISPLAY_APPS_SUCCESS_SAVE, SUCCESS_TEXT } from "../../messageText";
import { NavigationHeader } from "../../../_metronic/layout/components/navigationheader/NavigationHeader";
import UploadStudio from "../../Upload_Studio";
import { UPPY_BUCKET_URL } from "../../../../../../../actions/constant";


const backgroundFormatOptions = [
  { value: 0, label: "Background Color" },
  { value: 1, label: "Background Image" },
];
const logoPositionOptions = [
  { value: "flex-start", label: "Left" },
  { value: "flex-end", label: "Right" },
  { value: "center", label: "Center" },
];

const formats = [
  'font',
  'size',
  'bold', 'italic', 'underline',
  //   'list', 'bullet',
  'align',
  'color',
];
const modules = {
  toolbar: [
    [{ 'font': [] }],
    [{ 'size': ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline'],
    [{ 'align': [] }],
    [{ 'color': [] }],
    ['clean']
  ]
};
const limitText = 450;
class NoticeBoard extends Component {
  state = {
    text: '<p><strong class="ql-size-huge" style="color: rgb(32, 33, 36);">Enter Heading Here</strong></p><p><br></p><p><strong class="ql-size-large" style="color: rgb(32, 33, 36);">Enter Subheading</strong></p><p><br></p><p><span style="color: rgb(187, 187, 187);">Enter Description</span></p>',
    isBackground: 0,
    logoPosition: "center",
    Background: "",
    backgroundImage: "",
    logoIcon: "",
    selectedFile: null,
    selectedUrl: null,
    selectedName: null,
    selectedFileLogo: null,
    selectedUrlLogo: null,
    selectedNameLogo: null,
    uppyBackgroundOpen: false,
    uppyLogoOpen: false,
    updateApi: false,
    buttonDis:false,
    loader:false,
    stateChanged:false,
    upBg:0,
    upLogo:0,
    content: "",
    lastFormat: { size: "normal" },
  };

  componentDidMount() {
    const { scenes,location } = this.props;
    const { app_data } = scenes.updateSceneData;

    if (app_data && location.pathname.includes('update')) { 
      const { text, Background, backgroundImage, isBackground, logoIcon, logoPosition } = app_data;
      if (Background) this.setState({
        text, Background, backgroundImage, isBackground, logoIcon, logoPosition, updateApi: true
      });
    } else {
      this.setState({
        Background: "#cbe4f5"
      })
    }

    setTimeout(() => {
      window.$('#Noticeboardbg').minicolors({
        control: 'hue',
        defaultValue: this.validate_color(this.value) ? this.state.Background : '#fff',
        letterCase: 'lowercase',
        position: 'bottom left',
        change: this.onNoticeboardbgChange,
        theme: 'bootstrap'
      });
    })


     this.quill = this.reactQuillRef.getEditor();

    this.quill.on("selection-change", (range) => {
      if (range) {
        const currentFormat = this.quill.getFormat(range);
        if (Object.keys(currentFormat).length > 0) {
          this.setState({ lastFormat: currentFormat });
        }
      }
    });

    this.quill.on("text-change", () => {
      const range = this.quill.getSelection();
      if (!range) return;

      const currentFormat = this.quill.getFormat(range);
      // 🔥 If format is empty but we have a stored one, reapply it
      if (Object.keys(currentFormat).length === 0 && this.state.lastFormat) {
        Object.entries(this.state.lastFormat).forEach(([key, value]) => {
          this.quill.format(key, value);
        });
      }
    });

  }


  componentDidUpdate(preProps, nextProps) {
    if (preProps !== nextProps) {
      window.$('#Noticeboardbg').minicolors({
        control: 'hue',
        defaultValue: this.validate_color(this.value) ? this.state.Background : '#fff',
        letterCase: 'lowercase',
        position: 'bottom left',
        change: this.onNoticeboardbgChange,
        theme: 'bootstrap'
      })
    };
  }


  validate_color = (c) => {
    var litmus = 'red';
    var d = document.createElement('div');
    d.style.color = litmus;
    d.style.color = c;
    if (c !== litmus && (d.style.color === litmus || d.style.color === '')) {
      return false;
    }
    return true;
  }

  onNoticeboardbgChange = (value) => {
    this.setState({ Background: value, stateChanged : true })
  }

  handleOpen = event => this.setState({
    uppyBackgroundOpen: true, stateChanged : true
    
  })
  handleClose = event => this.setState({
    uppyBackgroundOpen: false, stateChanged : true
  })
  uppyLogoOpen = event => this.setState({
    uppyLogoOpen: true, stateChanged : true
  })
  uppyLogoClose = event => this.setState({
    uppyLogoOpen: false, stateChanged : true
  })
  removeLogoImage = event => this.setState({
    logoIcon: '', selectedUrlLogo: '', selectedNameLogo: '', upLogo : Math.random()
  })

  removeBgImage = event => this.setState({
    backgroundImage: '', selectedUrl: '', selectedName: '', upBg : Math.random()
  })

  onTimerSave = (event) => {
    const { param } = this.props;
    const { text, isBackground, Background, backgroundImage, logoPosition, logoIcon } = this.state;
    if (!text || text === '') {
      Swal.fire({
        title: 'Error',
        text: 'Please enter correct text!',
        type: "error",
        icon: 'error',
        showConfirmButton: false,
        timer: 3000
      });
      return;
    }
  
    this.state.updateApi
      ? this.props.updateApp(
        param.contentMixId,
        this.props.scenes.updateSceneData.id,
        { text, isBackground, Background, backgroundImage, logoPosition, logoIcon },
        9,
        this.onSaveCallBack
      )
      : this.props.addApp(
        param.contentMixId,
        param.positionID,
        { text, isBackground, Background, backgroundImage, logoPosition, logoIcon },
        "Notice Board",
        9,
        this.onSaveCallBack
      );
  };

  onBack = (event) => {
    const { params } = this.props.match;
    const { pathname } = this.props.location; 

    if (!this.state.stateChanged) {
      this.props.history(stripTrailingSlash(pathname,params))
      return;
    }
    
    Swal.fire({
      title: "Are you sure?",
      text: "Your changes have not been saved. Do you want to save before you leave the page?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Save",
      cancelButtonText: "Discard Changes",
      reverseButtons: true,
      customClass: customClass

    }).then((result) => {
      if (result.value) { 
        this.onTimerSave()
      } else if (result.dismiss === "cancel") {
        this.props.history(stripTrailingSlash(pathname,params))
      }
    });
  };

  onSaveCallBack = () => {
     
    const { params } = this.props.match;
    this.props.USER_STUDIO_WALL(params.wallId);
    Swal.fire({
      title: SUCCESS_TEXT,
      text: DISPLAY_APPS_SUCCESS_SAVE,
      type: "success",
      icon: "success",
      showConfirmButton: false,
      timer: 3000,
    }).then((result) => {
      if (this.state.backgroundImage) this.resetUppy();
      if (this.state.logoIcon) this.resetUppy();
      this.setState({
        text: '<p><strong class="ql-size-huge" style="color: rgb(32, 33, 36);">Enter Heading Here</strong></p><p><br></p><p><strong class="ql-size-large" style="color: rgb(32, 33, 36);">Enter Subheading</strong></p><p><br></p><p><span style="color: rgb(187, 187, 187);">Enter Description</span></p>',
        isBackground: 0,
        logoPosition: "center",
        Background: "",
        backgroundImage: "",
        logoIcon: "",
        selectedFile: null,
        selectedUrl: null,
        selectedName: null,
        selectedFileLogo: null,
        selectedUrlLogo: null,
        selectedNameLogo: null,
        uppyBackgroundOpen: false,
        uppyLogoOpen: false,
        updateApi: false
      })
      this.props.history(`/studio/${params.wallId}`);
      this.setState({ buttonDis:false, loader:false })
    });
  };


  resetUppy=()=>{  
    const uppyTotal = window.$(".uppy-u-reset");  
    if(uppyTotal && (uppyTotal.length==1 || uppyTotal.length==2)){
        window.$(".uppy-u-reset").click();
    }
}

  onUpdateColor = (color) => {
    this.setState({ colorUpdate: color.hex, Background: color.hex })
  }

  changeBackgroundUpdate = (event) => {
    this.setState({ isBackground: event.value });
  };
  changelogoPositionUpdate = (event) => {
    this.setState({ logoPosition: event.value });
  };


  

  rteChange = (content, delta, source, editor) => {

    if (this.reactQuillRef) {
       let quill = this.reactQuillRef.getEditor();
       if(parseInt(editor.getLength()) > limitText)  quill.deleteText(limitText, editor.getLength());
        this.setState({ content: content, value: content });
    }
    this.setState({ text: editor.getHTML() })
  }

  handleChange = (value) => {
    this.setState({ content: value });
  };


  updateBackground = event => this.setState({ backgroundImage: `${UPPY_BUCKET_URL}media/tmpimages/${event.id}.${event.ext}`, selectedUrl: `${UPPY_BUCKET_URL}media/tmpimages/${event.id}.${event.ext}`, selectedName: event.name, stateChanged:true })
  
  updateLogo = event => this.setState({ logoIcon: `${UPPY_BUCKET_URL}media/tmpimages/${event.id}.${event.ext}`, selectedUrlLogo: `${UPPY_BUCKET_URL}media/tmpimages/${event.id}.${event.ext}`, selectedNameLogo: event.name, stateChanged:true })

  
  render() {
    const { match, name } = this.props;
    const {
      isBackground,
      logoPosition,
      buttonDis,
      logoIcon,
      backgroundImage,
      loader,
      upBg,
      upLogo,
      updateApi
    } = this.state;
    const { pathname } = this.props.location; 
    const isUpdate =  window.location.href.includes('update')


    return (
      <> 
         { !updateApi ? <NavigationHeader
                name={name} 
                backToNavigation={`${pathname ? stripTrailingSlash(pathname,match) : ''}`}
            /> : null }
        <div className="container-fluid subheader_content">
          <Card className="select_wall mb-3 rounded-0 border-0 notic_board">
            <Card.Body className="p-0">
              <Row>
                <Col lg={4} className="border-right-lg">
                  <Card className="border-0 rounded-0">
                    <Card.Body className="p-4 card_height">
                      <Form>
                        <Form.Group  className="form-group"controlId="text-option">
                          <Form.Label>Text</Form.Label>
                            <div>
                              <ReactQuill theme="snow" name="description" ref={(el) => { this.reactQuillRef = el }} modules={modules} height="320"
                                formats={formats} onChange={this.rteChange}
                                value={this.state.text || ''} />
                                </div>   
                            </Form.Group>
                        

                        <Row>
                          <Col xl>
                            <Form.Group className="form-group" controlId="text-background">
                              <Form.Label>Background</Form.Label>
                              <Select
                                value={backgroundFormatOptions.find(option => option.value === isBackground)}
                                onChange={this.changeBackgroundUpdate}
                                options={backgroundFormatOptions}
                              />
                            </Form.Group>
                          </Col>
                          <Col xl>
                            {isBackground == 0 && <Form.Group className="form-group" controlId="background-color">
                              <Form.Label>Background Color</Form.Label>
                              <div className="w-100 notice_board_color">

                                <input className="form-control minicolors-input" maxlength="10" type="text" id="Noticeboardbg" defaultValue={this.state.Background} />
                              </div>
                            </Form.Group>}
                            {isBackground == 1 && <Form.Group className="form-group" controlId="background-image">
                              <Form.Label>Background Image</Form.Label>
                              <div className="w-100 notice_board_bg">
                                <UploadStudio picture={backgroundImage} pic={'bg'} key={upBg} removeImage={this.removeBgImage} updateImage={this.updateBackground}  />
                              </div>
                            </Form.Group>}
                          </Col>
                        </Row>
                        <Row>
                          <Col xl>
                            <Form.Group className="form-group" controlId="logo">
                              <Form.Label>Logo</Form.Label>
                              <UploadStudio picture={logoIcon} pic={'logo'} key={upLogo} removeImage={this.removeLogoImage} updateImage={this.updateLogo}  />
                            </Form.Group>

                          </Col>
                          <Col xl>
                            <Form.Group className="form-group" controlId="text-background">
                              <Form.Label>Logo Position</Form.Label>
                              <Select
                                value={logoPositionOptions.find(option => option.value === logoPosition)}
                                onChange={this.changelogoPositionUpdate}
                                options={logoPositionOptions}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Form>
                    </Card.Body>
                    <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-3">
                      <button
                        className="btn btn-outline-dark me-3 btn-min-w"
                        onClick={this.onBack}
                      >
                        <span className="position-relative">Back</span>
                    </button>
                      <Button
                        variant="primary"
                        disabled={ buttonDis } className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`}
                        onClick={this.onTimerSave}
                        id="Studio_Noticeboard_App_Users"
                      >
                        Save
                    </Button>
                    </Card.Footer>
                  </Card>
                </Col>
                <Col
                  lg={8} style={{ alignItems: 'normal!important' }}
                  className="d-flex  justify-content-center"
                >
                  <Card className="border-0 card w-100">
                    <Card.Body className="border-0">
                      <div className="wall_view">
                        <div className="wall_view_wrapper">
                          <NoticeBoardPreview {...this.state} />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>

        </div> </>

    );
  }
}
const mapStateToProps = (state) => {
  return {
    studioWall: state.studio.studioWall,
    scenes: state.scene,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addApp: (contentMixId, position, appContent, appName, appId, callBack) =>
      dispatch(
        addApp(contentMixId, position, appContent, appName, appId, callBack)
      ),
    updateApp: (contentMixId, sceneContentId, appContent, appId, callBack) =>
      dispatch(
        updateApp(contentMixId, sceneContentId, appContent, appId, callBack)
      ),
      USER_STUDIO_WALL: (wallID) => dispatch(USER_STUDIO_WALL(wallID)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NoticeBoard);
